import {Component, Input, OnInit, ViewChild} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService } from "primeng/api";
import { NavService } from "../../../../_services/_nav.service";
import { FlujoVentaPasoRestriccionPerfilVinculacionService } from "../../../../_services/flujo-venta-paso-restriccion-perfil-vinculacion.service";
import { TabViewCustom } from "../../../../_models/tab-view-custom";
import { PoliticaService } from '../../../../_services/politica.service';
import { PoliticaAPL } from "../../../../_enums/enum";
import { PoliticasConfiguradasService } from '../../../../_services/politicas-configuradas.service';
import { PoliticaConfigurada } from "../../../../_models/politica-configurada";
import {FlujoVentaPasoService} from "../../../../_services/flujo-venta-paso.service";
import { Table } from "primeng/table";
import {forkJoin} from "rxjs";
import { PoliticaFlujoVenta } from '../../../../_models/politica-flujo-venta';
import { Politica } from '../../../../_models/politica';

@Component({
  selector: 'app-flujo-venta-politicas-configuradas',
  templateUrl: './flujo-venta-politicas-configuradas.component.html',
  styleUrls: ['./flujo-venta-politicas-configuradas.component.css']
})
export class FlujoVentaPoliticasConfiguradasComponent implements OnInit {
  @Input() tabView: TabViewCustom;
  @ViewChild('dt') tabla: Table;
  busqueda: string;
  formulario: FormGroup;
  listaPoliticasConfiguradas: PoliticaConfigurada[] = [];
  listaPoliticasConfiguradasTodas: PoliticaConfigurada[] = [];
  listaPoliticasMultiSelect = [];
  listaPoliticasMultiSelectTodas = [];
  submitted = false;
  cargando = true;
  guardando = false;
  columnas: any[];
  flujoVentaPasos

  constructor(
    private navServicio: NavService,
    private fb: FormBuilder,
    private politicaService: PoliticaService,
    private politicasConfiguradasService: PoliticasConfiguradasService,
    private flujoVentaPasoRestriccionPerfilVinculacionService: FlujoVentaPasoRestriccionPerfilVinculacionService,
    private confirmService: ConfirmationService,
    private fluVentaPasoService: FlujoVentaPasoService,
  ) {}

  async ngOnInit() {
    this.setearColumnas();
    this.listaPoliticasMultiSelect = [];
    this.listaPoliticasMultiSelectTodas = [];
    this.cargarFormulario();
    await this.cargarTabla();
    this.busqueda = this.navServicio.getSearch( 'flujo-venta.component' );
  }

  async llenarMultiSelect( polConfig ) {
    this.listaPoliticasMultiSelect=[];
    await this.politicaService.listadoPoliticas().subscribe(
      ( politica ) => {
        politica.map( (politicaItem) =>{
          if (
            politicaItem.indicadorHabilitado &&
            ( polConfig ? !( this.listaPoliticasConfiguradas.find( x => x.idPolitica === politicaItem.idPolitica ) ) : true ) &&
            ( politicaItem.codigoCategoriaPolitica === PoliticaAPL.POLCRE )
          ){
            this.listaPoliticasMultiSelectTodas.push(politicaItem);
            if (!politicaItem.indicadorPoliticaGlobal && !(this.listaPoliticasConfiguradas.find( x => x.idPolitica === politicaItem.idPolitica))){
              this.listaPoliticasMultiSelect.push( { label: politicaItem.nombre, value: politicaItem.idPolitica } )
            }
          }
        })
      }
    );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'flujo-venta.component', this.busqueda );
  }

  async cargarTabla() {
    this.cargando = true;
    this.listaPoliticasConfiguradas = [];
    forkJoin(
      this.politicasConfiguradasService.listEnabled(),
      this.politicasConfiguradasService.list(),
      this.politicaService.listadoPoliticas()
    ).subscribe( async ( [ polEnabled, pol, listPoliticas ] ) => {
      polEnabled.map((s: PoliticaConfigurada) => {
        let temp = {} as PoliticaFlujoVenta;
          temp.codigoPolitica = s.codigoPolitica;
          temp.politica = s.politica;
          temp.categoriaPolitica = s.categoriaPolitica;
          temp.indicadorPoliticaProducto = s.indicadorPoliticaProducto;
          temp.indicadorPoliticaModalidad = s.indicadorPoliticaModalidad;
          temp.indicadorPoliticaGlobal = s.indicadorPoliticaGlobal;
          temp.indicadorHabilitado = s.indicadorHabilitado;
          temp.idPolitica = s.idPolitica;
          temp.codigoCategoriaPolitica = s.codigoCategoriaPolitica;
          temp.idFlujoVentaPaso = s.idFlujoVentaPaso;
          temp.politicaModalidad = s.indicadorPoliticaProducto ? this.navServicio.buscarMensaje(
            "POLITICAS.LBL_POLITICAPRODUCTO") : s.indicadorPoliticaModalidad ? this.navServicio.buscarMensaje("POLITICAS.LBL_POLITICAMODALIDAD") : this.navServicio.buscarMensaje("POLITICAS.LBL_POLITICAGLOBAL")
          this.listaPoliticasConfiguradas.push(temp);
        }
      );

      this.listaPoliticasConfiguradasTodas = pol;
      await this.llenarMultiSelect( this.listaPoliticasConfiguradas.length > 0 );
      this.cargando = false;
    } )
  }

  /* columnas del data table */
  setearColumnas() {
    this.columnas = [
      {
        field: "codigoPolitica",
        header: this.navServicio.buscarMensaje(
          "FLUJOVENTASPOLITICASCONFIGURADAS.LBL_CODIGO"
        ),
        sort: false,
      },
      {
        field: "politica",
        header: this.navServicio.buscarMensaje(
          "FLUJOVENTASPOLITICASCONFIGURADAS.LBL_NOMBREPOLITICA"
        ),
        sort: false,
      },
      {
        field: "categoriaPolitica",
        header: this.navServicio.buscarMensaje(
          "FLUJOVENTASPOLITICASCONFIGURADAS.LBL_CATEGORIAPOLITICA"
        ),
        sort: false,
      },
      {
        field: "politicaModalidad",
        header: this.navServicio.buscarMensaje(
          "FLUJOVENTASPOLITICASCONFIGURADAS.LBL_TIPOPOLITICA"
        ),
        sort: false,
      },
      {
        field: "acciones",
        header: this.navServicio.buscarMensaje(
          "FLUJOVENTASPOLITICASCONFIGURADAS.LBL_ACCIONES"),
        sort: false,
      },
    ];
  }

  /* carga del formulario */
   cargarFormulario() {
     this.formulario = this.fb.group({
       idsPoliticas: [null, [Validators.required]],
     });
   }

  validarExistentes() {
     return new Promise(async (resolve, reject) => {
       await this.f.idsPoliticas.value.map( ( x, ind ) => {
         const coincide = this.listaPoliticasConfiguradasTodas.find( y => y.idPolitica === x );
         if ( coincide ) {
           coincide.indicadorHabilitado = true;
           this.politicasConfiguradasService.put( coincide ).subscribe(
               (res) => {
                 this.formulario.reset();
                 this.submitted = false;
                 this.guardando = false;
                 this.cargarTabla();
                 console.log( "ok" )
               },
             (error) => {
               reject( error );
               }
           );
           this.f.idsPoliticas.value.splice( ind, 1 );
         }
       })
       await resolve( true );
     })
   }

   limpiarSelect( registros ) {
    this.f.idsPoliticas.value.map( ( x, ind ) => {
      const coincide = registros.find(y => y.idPolitica === x);
      if ( coincide )
        this.f.idsPoliticas.value.splice( ind, 1 );
    })
  }



  /* agregar */
  async onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      this.guardando = true;
      let registros = [];
      await this.validarExistentes();
      console.log('this.f.idsPoliticas.value',this.f.idsPoliticas.value)
       await this.f.idsPoliticas.value.map( ( x ) => {
        let politica = this.listaPoliticasMultiSelectTodas.filter( y => y.idPolitica === x );
        if ( politica.length > 0 ) {
          politica[0].idFlujoVentaPaso = this.tabView.flujoVenta.idFlujoVentaPaso;
          registros.push( politica[0] );
        }
      } )

      if ( registros.length < 1 ) {
        console.log( "No encontró coincidencias al filtrar en las politicas" );
        return true;
      }

      let evento = registros.length > 1 ? 'bulk' : 'post';

      await this.politicasConfiguradasService[evento]( registros.length > 1 ? registros : registros[0] ).subscribe(
        ( res ) => {
          this.limpiarSelect( registros );
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
          this.cargarTabla();
        },
        ( error ) => {
          console.log( error );
        }
        );
    }
  }

  /* controles del formulario */
  get f() {
    return this.formulario.controls;
  }

  /* inhabilitar un registro */
  inhabilitar(row) {
     this.confirmService.confirm({
       message: this.navServicio.buscarMensaje("MSG_INHABILITAR"),
       header: this.navServicio.buscarMensaje("LBL_CONFIRMACION"),
       icon: "fa fa-question-circle",
       key: "form-politicas-configuradas",
       accept: () => {
         this.guardando = true;
         row.indicadorHabilitado = false;
         this.politicasConfiguradasService
           .put(row)
           .subscribe(
             (res) => {
               this.navServicio.setMesage(2);
               this.formulario.reset();
               this.submitted = false;
               this.guardando = false;
               this.cargarTabla();
             },
             (error) => {
               this.navServicio.setMesage(3);
               this.formulario.reset();
               this.submitted = false;
               this.guardando = false;
             }
           );
       },
       reject: () => {},
     });
  }

}
